// extracted by mini-css-extract-plugin
export var avatarContainer = "_g4-0";
export var gray = "_g4-f";
export var green = "_g4-c";
export var icon = "_g4-9";
export var image = "_g4-1";
export var lg = "_g4-6";
export var md = "_g4-5";
export var presenceDot = "_g4-b";
export var red = "_g4-d";
export var sm = "_g4-4";
export var status = "_g4-a";
export var xl = "_g4-7";
export var xs = "_g4-3";
export var xxl = "_g4-8";
export var xxs = "_g4-2";
export var yellow = "_g4-e";